import axios from 'axios';

import router from '@/router';
import auth from '@/utils/auth';

import {
  DELETE_COOWNER,
  DELETE_COOWNER_ERROR,
  DELETE_COOWNER_SUCCESS,

  GET_COOWNER,
  GET_COOWNER_ERROR,
  GET_COOWNER_SUCCESS,

  GET_COOWNERS,
  GET_COOWNERS_ERROR,
  GET_COOWNERS_SUCCESS,

  SAVE_COOWNER,
  SAVE_COOWNER_ERROR,
  SAVE_COOWNER_SUCCESS,

  SAVE_SYNDICATE_SECTION,
  SAVE_SYNDICATE_SECTION_ERROR,
  SAVE_SYNDICATE_SECTION_SUCCESS,

  ADD_SECTION,
  ADD_SECTION_ERROR,
  ADD_SECTION_SUCCESS,

  ADD_ATTACHMENT,
  ADD_ATTACHMENT_ERROR,
  ADD_ATTACHMENT_SUCCESS,

  GET_ALL_SECTION,
  GET_ALL_SECTION_ERROR,
  GET_ALL_SECTION_SUCCESS,

  GET_ALL_SYNDICATE_SECTION,
  GET_ALL_SYNDICATE_SECTION_ERROR,
  GET_ALL_SYNDICATE_SECTION_SUCCESS,

  GET_FIELDS,
  GET_FIELDS_ERROR,
  GET_FIELDS_SUCCESS,

  ADD_FIELDS,
  ADD_FIELDS_ERROR,
  ADD_FIELDS_SUCCESS,

  DELETE_FIELDS,
  DELETE_FIELDS_ERROR,
  DELETE_FIELDS_SUCCESS,

  DELETE_SYNDICATE_FIELDS,
  DELETE_SYNDICATE_FIELDS_SUCCESS,
  DELETE__SYNDICATE_FIELDS_ERROR,

  DELETE_SETTING_SECTION,
  DELETE_SETTING_SECTION_ERROR,
  DELETE_SETTING_SECTION_SUCCESS,

  DOWNLOAD_COOWNERS,
  DOWNLOAD_COOWNERS_ERROR,
  DOWNLOAD_COOWNERS_SUCCESS,
  COOWNER_SECTION_PERMISSION,
} from './constants';

export default {
  async [DELETE_COOWNER]({ commit }, coownerID) {
    try {
      commit(DELETE_COOWNER);
      await axios({
        url: `${process.env.API_URL}/api/coowners/${coownerID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_COOWNER_SUCCESS);
      router.push({ name: 'Coowner Listing' });
    } catch (err) {
      commit(DELETE_COOWNER_ERROR, err);
    }
  },

  async [GET_COOWNER]({ commit }, data) {
    try {
      commit(GET_COOWNER);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowners/${data.coownerID}/${data.syndicateID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_COOWNER_SUCCESS, response.data);
    } catch (err) {
      commit(GET_COOWNER_ERROR, err);
    }
  },

  async [GET_COOWNERS]({ commit }, syndicateID) {
    try {
      commit(GET_COOWNERS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/coowners`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_COOWNERS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_COOWNERS_ERROR, err);
    }
  },

  async [SAVE_SYNDICATE_SECTION]({ commit }, data) {
    try {
      commit(SAVE_SYNDICATE_SECTION);
      let url = `${process.env.API_URL}/api/coowners/section`;
      let method = 'POST';
      // eslint-disable-next-line array-callback-return
      if (data.every(e => e.coownersSectionID)) {
        url = `${url}/update`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_SYNDICATE_SECTION_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_SYNDICATE_SECTION_ERROR, err);
    }
  },

  async [SAVE_COOWNER]({ commit }, data) {
    try {
      const updatedData = { ...data, sections: { ...data.sections } };
      // eslint-disable-next-line no-restricted-syntax
      for (const key in data) {
        if (key.includes('_')) {
          const parentKey = key.split('_')[1];
          const childKey = key.split('_')[0];
          if (
            updatedData.sections[parentKey] && updatedData.sections[parentKey].fields[childKey]
          ) {
            updatedData.sections[parentKey].fields[childKey] = {
              ...updatedData.sections[parentKey].fields[childKey],
              textData: data[key] || '',
            };
          }
        }
      }
      commit(SAVE_COOWNER);
      let url = `${process.env.API_URL}/api/coowners`;
      let method = 'POST';
      if (data.coownerID) {
        url = `${url}/${data.coownerID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_COOWNER_SUCCESS, response.data);
      if (method === 'POST') {
        router.push({ name: 'Coowner Listing' });
      }
    } catch (err) {
      commit(SAVE_COOWNER_ERROR, err);
    }
  },

  async [DOWNLOAD_COOWNERS]({ commit }, args) {
    try {
      commit(DOWNLOAD_COOWNERS);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowners/download`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
        },
      });
      commit(DOWNLOAD_COOWNERS_SUCCESS, response.data);
    } catch (err) {
      commit(DOWNLOAD_COOWNERS_ERROR, err);
    }
  },

  async [ADD_SECTION]({ commit }, data) {
    try {
      commit(ADD_SECTION);
      commit(ADD_SECTION_SUCCESS, data);
    } catch (err) {
      commit(ADD_SECTION_ERROR, err);
    }
  },

  async [ADD_ATTACHMENT]({ commit }, data) {
    try {
      commit(ADD_ATTACHMENT);
      const fd = new FormData();
      fd.append('documentUrl', data.file.value);
      fd.append('fieldDataID', data.fieldDataID);
      fd.append('coownerID', data.coownerID);
      fd.append('coownersFieldID', data.coownersFieldID);
      fd.append('coownersSectionID', data.coownersSectionID);

      const response = await axios({
        url: `${process.env.API_URL}/api/coowners/coownersField/uploadDocument`,
        method: 'POST',
        headers: {
          ...auth.getAuthHeader(),
          'Content-Type': 'multipart/form-data',
        },
        data: fd,
      });
      commit(ADD_ATTACHMENT_SUCCESS, response.data);
    } catch (err) {
      commit(ADD_ATTACHMENT_ERROR);
    }
  },

  async [GET_ALL_SECTION]({ commit }, coownerID) {
    try {
      commit(GET_ALL_SECTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowners/${coownerID}/section`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_ALL_SECTION_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ALL_SECTION_ERROR, err);
    }
  },

  async [GET_ALL_SYNDICATE_SECTION]({ commit }, syndicateID) {
    try {
      commit(GET_ALL_SYNDICATE_SECTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/coowners/section`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_ALL_SYNDICATE_SECTION_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ALL_SYNDICATE_SECTION_ERROR, err);
    }
  },

  async [GET_FIELDS]({ commit }) {
    try {
      commit(GET_FIELDS);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowners/fieldtypes`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_FIELDS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_FIELDS_ERROR, err);
    }
  },

  async [ADD_FIELDS]({ commit }, data) {
    try {
      commit(ADD_FIELDS);
      commit(ADD_FIELDS_SUCCESS, data);
    } catch (err) {
      commit(ADD_FIELDS_ERROR, err);
    }
  },

  async [DELETE_FIELDS]({ commit }, fieldID) {
    try {
      commit(DELETE_FIELDS);
      commit(DELETE_FIELDS_SUCCESS, fieldID);
    } catch (err) {
      commit(DELETE_FIELDS_ERROR, err);
    }
  },

  async [DELETE_SYNDICATE_FIELDS]({ commit }, data) {
    try {
      commit(DELETE_SYNDICATE_FIELDS);
      if (data.FieldIds.length > 0) {
        await axios({
          url: `${process.env.API_URL}/api/coowners/field/${data.FieldIds.join(',')}`,
          method: 'DELETE',
          headers: auth.getAuthHeader(),
        });
      }
      commit(DELETE_SYNDICATE_FIELDS_SUCCESS, data.data);
    } catch (err) {
      commit(DELETE__SYNDICATE_FIELDS_ERROR, err);
    }
  },

  async [DELETE_SETTING_SECTION]({ commit }, data) {
    try {
      commit(DELETE_SETTING_SECTION);
      if (data.coownersSectionID && data.isSettings === true) {
        await axios({
          url: `${process.env.API_URL}/api/coowners/section/${data.coownersSectionID}`,
          method: 'DELETE',
          headers: auth.getAuthHeader(),
        });
      }
      commit(DELETE_SETTING_SECTION_SUCCESS, data);
    } catch (err) {
      commit(DELETE_SETTING_SECTION_ERROR, err);
    }
  },

  async [COOWNER_SECTION_PERMISSION]({ commit }, data) {
    try {
      commit(COOWNER_SECTION_PERMISSION);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowner/section/show`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(COOWNER_SECTION_PERMISSION, response.data);
    } catch (err) {
      commit(COOWNER_SECTION_PERMISSION, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Coowners/actions.js